import React from "react";

const SendFormatClass = ({className}) => {
    return className.replaceAll('Volga/Posting/Integration/', '');
};

export default SendFormatClass;
